module.exports = __webpack_public_path__ + "img/16m.2f8668b5.png";